import { render } from "./ControlCard.vue?vue&type=template&id=2fe8d3d6&scoped=true"
import script from "./ControlCard.vue?vue&type=script&lang=js"
export * from "./ControlCard.vue?vue&type=script&lang=js"

import "./ControlCard.vue?vue&type=style&index=0&id=2fe8d3d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe8d3d6"]])

export default __exports__